import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Input } from "antd";
import { ReactSVG } from "react-svg";
import { isEmpty, filter } from "lodash";

import ListContainer from "../../../modules/contact/containers/List";
import ContactsTable from "../../Table/Contacts";

import { getTranslation } from "../../../utils/helper";
import "./DefaultContactLocation.scss";

const DefaultContactLocationForm = ({
  isFetching,
  contacts,
  doGetAllContacts,
  state,
  setState,
  handleCancel,
  handleSubmit,
  title,
  mutiSelect = false,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    doGetAllContacts({ itemsPerPage: 10000 });
  }, []);

  useEffect(() => {
    setFilteredContacts(contacts);
  }, [contacts]);

  useEffect(() => {
    const contactsT = filter(
      contacts,
      c =>
        c.name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
        c.phone?.toLowerCase().includes(searchValue?.toLowerCase()) ||
        c.address.toLowerCase().includes(searchValue?.toLowerCase()),
    );
    setFilteredContacts(contactsT);
  }, [searchValue]);

  const handleSelectContact = item => {
    if (mutiSelect) {
      let contactsT = [...state.contacts];
      if (contactsT.includes(item)) {
        contactsT = filter(contactsT, c => c._id !== item._id);
      } else {
        contactsT.push(item);
      }
      setState({
        ...state,
        contacts: contactsT,
      });
    } else {
      setState({
        ...state,
        contact: item,
      });
    }
  };

  const handleOnSubmit = () => {
    setSearchValue("");
    handleSubmit();
  };

  const handleOnCancel = () => {
    setSearchValue("");
    handleCancel();
  };

  const handleBulkUpdate = selectedItems => {
    return {
      title:
        selectedItems.length > 0
          ? `${selectedItems.length} ${getTranslation(setting, "Route Plans", "contacts selected")}`
          : "",
    };
  };

  const setSelectedContacts = contacts => {
    setState({ ...state, contacts });
  };

  return (
    <div className="DefaultContactLocationForm">
      <div className="FormHeader">
        <div className="left">{title || getTranslation(setting, "Contacts", "Select a contact")}</div>
      </div>
      <div className="FormContent">
        <div className="ContentFilters">
          <Input.Search
            placeholder="Search"
            allowClear
            onChange={e => setSearchValue(e.target.value)}
            size="large"
            value={searchValue}
          />
        </div>
        <div className="ContentMain">
          {mutiSelect ? (
            <ContactsTable
              rowKey="_id"
              loading={isFetching}
              pagination={false}
              dataSource={filteredContacts}
              setting={setting}
              bulkUpdate={handleBulkUpdate}
              selectedItems={state.contacts}
              setSelectedItems={setSelectedContacts}
              scrollHeight="calc(100vh - 420px)"
              isSortLocal={true}
              isKeepOldSelect={true}
            />
          ) : (
            <ContactsTable
              rowKey="_id"
              loading={isFetching}
              pagination={false}
              dataSource={filteredContacts}
              setting={setting}
              selectContact={true}
              mutiSelectContact={mutiSelect}
              selectedContact={state.contact}
              selectedContacts={state.contacts}
              handleSelectContact={handleSelectContact}
              scrollHeight="calc(100vh - 420px)"
              isSortLocal={true}
              isKeepOldSelect={true}
            />
          )}
        </div>
      </div>
      <div className="FormFooter">
        <div className="Left"></div>
        <div className="Right">
          <Button key="cancel" onClick={handleOnCancel}>
            {getTranslation(setting, "Common", "Cancel")}
          </Button>
          <Button type="primary" disabled={isEmpty(state.contact) && isEmpty(state.contacts)} onClick={handleOnSubmit}>
            {getTranslation(setting, "Common", "Confirm")}
            <ReactSVG className="icon" src="/icons/submit.svg" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ListContainer(DefaultContactLocationForm);
